/** `title` makes the icon announce itself; without one it is decorative. */
type Props = { className?: string; title?: string }

/** The red triangle with an exclamation mark the editor uses for errors. */
export const TriangleAlertIcon = ({ className, title }: Props) => (
	<svg
		className={className}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role={title ? "img" : undefined}
		aria-label={title}
		aria-hidden={title ? undefined : true}
	>
		<path
			d="M8 6V9M8 11H8.005M6.86 2.57L1.79 11.0001C1.6132 11.3068 1.51943 11.6544 1.5184 12.0085C1.51738 12.3626 1.60914 12.7107 1.78416 13.0184C1.95919 13.326 2.21134 13.5825 2.51578 13.7625C2.82022 13.9425 3.16637 14.0398 3.52 14.0445H13.66C14.0136 14.0398 14.3598 13.9425 14.6642 13.7625C14.9687 13.5825 15.2208 13.326 15.3958 13.0184C15.5709 12.7107 15.6626 12.3626 15.6616 12.0085C15.6606 11.6544 15.5668 11.3068 15.39 11.0001L10.32 2.57C10.1444 2.27148 9.89274 2.02351 9.59042 1.85077C9.2881 1.67802 8.94634 1.58655 8.598 1.58655C8.24966 1.58655 7.9079 1.67802 7.60558 1.85077C7.30326 2.02351 7.05162 2.27148 6.876 2.57H6.86Z"
			stroke="#EC404C"
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
